import React from 'react'
import PropTypes from 'prop-types'
import { _ } from '@iskytrip/sdk'
import CSS from './index.module.scss'
import BaseComponent from '@base/BaseComponent'
import { IconCodeEmum, Iconfont } from '@src/components'
import VoucherSelected from '@assets/images/voucher-status-5.png'
import { Modal } from 'antd-mobile'

// 权益券列表、优惠券列表、优惠活动列表
class CouponModal extends BaseComponent {
	static propTypes = {
		isShow: PropTypes.bool,
		title: PropTypes.string,
		couponList: PropTypes.array,
		close: PropTypes.func,
		receiveCoupon: PropTypes.func,
	}

	static defaultProps = {
		title: '',
		isShow: false,
		couponList: [],
		close: () => {},
		receiveCoupon: () => {},
	}

	/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ 生命周期 */
	constructor(props) {
		super(props)
		this.state = {}
	}

	componentDidUpdate() {}

	render() {
		let { isShow, couponList, title, close, receiveCoupon } = this.props
		// console.log('couponList ===', couponList)

		return (
			<Modal
				popup
				visible={isShow}
				className={CSS.modalCoupon}
				animationType='slide-up'
				onClose={close.bind(this)}
			>
				<div className={CSS.scrollViewComp}>
					<div className={CSS.modalTitle}>
						<label>{title}</label>
						<Iconfont
							font={IconCodeEmum.CLOSE}
							style={{ fontSize: '.32rem', color: '#D8D8D8' }}
							onPress={close.bind(this)}
						/>
					</div>
					<div className={CSS.modalContent}>
						{couponList &&
							couponList.map((item, index) => (
								<div className={CSS.cell} key={index}>
									<div className={CSS.cellLeft}>
										<label className={CSS.cellLeftInner}>
											<label className={CSS.cellLeftInnerText1}>
												{item.discountValue}
											</label>
											<label className={CSS.cellLeftInnerText2}>
												{item.unit}
											</label>
										</label>
										<label className={CSS.cellLeftText}>{item.subTitle}</label>
									</div>
									<div className={CSS.cellMiddle}>
										<div className={CSS.con_name}>
											{item.gainIdentityStr ? (
												<label className={CSS.member_tag}>
													{item.gainIdentityStr}
												</label>
											) : null}
											<label className={CSS.cellMiddleText1}>
												{item.couponName}
											</label>
										</div>

										<label className={CSS.cellMiddleText2}>
											{item.startValidDate || ''} - {item.endValidDate || ''}
										</label>
									</div>
									<div className={CSS.cellRight}>
										{/* displayStatus 1：已领取 2: 立即领取 98:已作废 99:已过期 */}
										{item.btnDisplayValue && item.displayStatus === 2 ? (
											<label
												className={CSS.cellRightText}
												onClick={receiveCoupon.bind(this, item)}
											>
												{item.btnDisplayValue}
											</label>
										) : null}
									</div>
									{item.displayStatus !== 2 ? (
										<img
											className={CSS.cellTip}
											src={VoucherSelected}
											alt='icon'
										/>
									) : null}
								</div>
							))}
					</div>
				</div>
			</Modal>
		)
	}
}

export default CouponModal
